(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("shop-by-category")) {
    class ShopByCategory extends HTMLElement {
      connectedCallback() {
        this.itemsDesktop = parseInt(this.dataset.itemsDesktop || "4", 10);
        this.itemsTablet = parseInt(this.dataset.itemsTablet || "2", 10);
        this.itemsMobile = parseInt(this.dataset.itemsMobile || "1", 10);
        this.loop = this.dataset.loop === "true";
        this.peek = this.dataset.peek === "true";
        this.peekAmount = parseInt(this.dataset.peekAmount || "15", 10) / 100;
        this.gap = parseInt(this.dataset.gap || "16", 10);
        this.gapMobile = parseInt(this.dataset.gapMobile || "12", 10);
        this.tabs = Array.from(this.querySelectorAll("[data-shop-by-tab]"));
        this.panels = Array.from(this.querySelectorAll("[data-shop-by-panel]"));

        this.style.setProperty("--shop-by-items-desktop", this.itemsDesktop);
        this.style.setProperty("--shop-by-items-tablet", this.itemsTablet);
        this.style.setProperty("--shop-by-items-mobile", this.itemsMobile);

        this.bindTabs();
        this.initActiveSlider();

        document.addEventListener("shopify:block:select", (event) => this.handleThemeEditorSelect(event));
      }

      bindTabs() {
        this.tabs.forEach((tab) => {
          if (tab.dataset.shopByBound === "true") return;
          tab.dataset.shopByBound = "true";
          tab.addEventListener("click", () => this.setActiveTab(tab.dataset.shopByTab));
        });
      }

      setActiveTab(tabKey) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.shopByTab === tabKey;
          tab.classList.toggle("is-active", active);
          tab.setAttribute("aria-selected", active ? "true" : "false");
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.shopByPanel !== tabKey;
        });

        this.initActiveSlider();
      }

      initActiveSlider() {
        const panel = this.panels.find((item) => !item.hidden) || this.panels[0];
        if (!panel) return;

        const sliderElement = panel.querySelector(".m-shop-by-category__slider");
        const track = panel.querySelector(".m-shop-by-category__track");
        if (!sliderElement || !track || typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) return;

        if (sliderElement.swiper) {
          sliderElement.swiper.destroy(false, true);
        }

        const slideCount = track.children.length;
        if (slideCount <= 0) return;

        const mobileSlides = this.peek && this.itemsMobile === 1 ? this.itemsMobile + this.peekAmount : this.itemsMobile;
        const tabletSlides = this.peek && this.itemsTablet === 1 ? this.itemsTablet + this.peekAmount : this.itemsTablet;

        sliderElement.classList.add("swiper-container");
        track.classList.add("swiper-wrapper");
        Array.from(track.children).forEach((slide) => slide.classList.add("swiper-slide"));

        new MinimogLibs.Swiper(sliderElement, {
          slidesPerView: mobileSlides,
          slidesPerGroup: 1,
          spaceBetween: this.gapMobile,
          loop: this.loop && slideCount > 1,
          threshold: 2,
          grabCursor: slideCount > 1,
          watchOverflow: true,
          breakpoints: {
            768: {
              slidesPerView: tabletSlides,
              slidesPerGroup: 1,
              spaceBetween: this.gap,
            },
            1280: {
              slidesPerView: this.itemsDesktop,
              slidesPerGroup: 1,
              spaceBetween: this.gap,
            },
          },
        });
      }

      handleThemeEditorSelect(event) {
        const selectedTab = event.target && event.target.querySelector("[data-shop-by-tab]");
        if (selectedTab) {
          this.setActiveTab(selectedTab.dataset.shopByTab);
          selectedTab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }
      }
    }

    customElements.define("shop-by-category", ShopByCategory);
  }

  } catch(e) { console.error(e); }
})();
})();
